const API_CONFIG = {
  BACKEND_URL: "https://8hkm9aoo7f.execute-api.eu-west-2.amazonaws.com/prod",
  BACKEND_COMPANY_API_URL:
    "https://5ht6l9vpo3.execute-api.eu-west-2.amazonaws.com/prod",
};

export default API_CONFIG;
